import moment from 'moment';
import { pageLang } from '../../../services/app-storage';
import { removeTimezone } from '../../../services/dates';
import InputField from '../../../services/input-fields/input-field';

// TODO: Deprecated, remove

export default class DateTimeField extends InputField {
    public hours: InputField;
    public minutes: InputField;

    constructor(dateId: string, hoursId: string, minutesId: string) {
        super(dateId);
        this.hours = new InputField(hoursId);
        this.minutes = new InputField(minutesId);

        this.$JQueryAll = this.$JQuery.add(this.hours.$JQuery).add(this.minutes.$JQuery);
    }

    public val(value?: string): string {
        if (value) {
            // Set value
            if (value === 'Invalid date') {
                console.warn('Tried to set an invalid date of a DateTimeField');
                return value;
            }

            const m: moment.Moment = moment(value);
            this.hours.$JQuery.val(m.hours());
            this.minutes.$JQuery.val(m.minutes());
            this.$JQuery.val(m.startOf('day').locale(pageLang).format('ll'));
            return value;
        } else {
            // Get value
            const hours = parseInt(this.hours.value, 10),
                minutes = parseInt(this.minutes.value, 10);

            const val = super.val();
            if (!val || hours === -1 || minutes === -1) {
                return '';
            } else {
                return moment(val, 'lll', pageLang)
                    .add({ hours, minutes }).format();
            }
        }
    }

    public getMoment(): moment.Moment | null {
        const hours = parseInt(this.hours.value, 10);
        const minutes = parseInt(this.minutes.value, 10);
        const date = super.val() || '';

        if (hours === -1 || minutes === -1 || date.length === 0) {
            return null;
        }

        return removeTimezone(moment(date, 'lll', pageLang)).add({
            hours,
            minutes
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/input-fields/datetime-field.ts